import { Button as AntButton, type ButtonProps as AntButtonProps } from "antd";
import React from "react";
// import { BackArrow } from "assets/icons";
import { SyncOutlined } from "@ant-design/icons";
import "./style.scss";

interface CustomButtonProps extends AntButtonProps {
  wFull?: boolean;
  isBack?: boolean;
  className?: string;
  height?: string | number;
  btnSize?: "none" | "sm" | "md" | "lg"; // renamed
  iconPosition?: "start" | "end";
  icon?: React.ReactNode;
}

const Button: React.FC<CustomButtonProps> = ({
  onClick,
  wFull,
  loading = false,
  disabled,
  href,
  children,
  className = "",
  btnSize = "md",
  type = "primary",
  isBack = false,
  iconPosition = "end",
  htmlType,
  icon,
  height,
  ...rest
}) => {
  const loadingState = loading ?? { icon: <SyncOutlined spin /> };

  return (
    <AntButton
      icon={icon || null}
      type={type}
      onClick={onClick}
      iconPosition={iconPosition}
      block={wFull}
      loading={loadingState}
      disabled={disabled}
      style={{ height }}
      href={href}
      htmlType={htmlType}
      className={`
        ${btnSize === "none" ? "transparent" : ""}
        ${btnSize === "lg" ? "btn-large" : ""}
        ${btnSize === "sm" ? "btn-small" : ""}
        ${btnSize === "md" ? "btn-medium" : ""}
        ${isBack ? "back-btn" : ""}
        ${className}
      `}
      {...rest}
    >
      {children}
    </AntButton>
  );
};

export default Button;
